var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactElementFactory, ReactQuestionFactory, SurveyQuestionText, SvgIcon, Popup } from "survey-react-ui";
var SurveyQuestionColor = /** @class */ (function (_super) {
    __extends(SurveyQuestionColor, _super);
    function SurveyQuestionColor(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(SurveyQuestionColor.prototype, "question", {
        get: function () {
            return this.questionBase;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionColor.prototype.renderInput = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement("input", { id: this.question.inputId, disabled: this.isDisplayMode, className: this.question.cssClasses.control, ref: function (input) { return (_this.setControl(input)); }, placeholder: this.question.renderedPlaceholder, autoComplete: "off", onKeyUp: function (event) { return _this.question.onKeyUp(event.nativeEvent); }, onBlur: function (event) { return _this.question.onBlur(event.nativeEvent); }, onChange: this.question.onChange, onBeforeInput: function (event) { return _this.question.onBeforeInput(event.nativeEvent); }, "aria-required": this.question.a11y_input_ariaRequired, "aria-labelledby": this.question.a11y_input_ariaLabelledBy, "aria-label": this.question.a11y_input_ariaLabel, "aria-invalid": this.question.a11y_input_ariaInvalid, "aria-describedby": this.question.a11y_input_ariaDescribedBy })));
    };
    SurveyQuestionColor.prototype.renderElement = function () {
        var _this = this;
        return (React.createElement("div", { className: this.question.cssClasses.root, onKeyDown: function (event) { return _this.question.onKeyDown(event.nativeEvent); } },
            this.renderColorSwatch(),
            this.renderInput(),
            this.question.showDropdownAction ? this.renderDropdownAction() : null));
    };
    SurveyQuestionColor.prototype.getValueCore = function () {
        return this.question.renderedValue;
    };
    SurveyQuestionColor.prototype.renderColorSwatch = function () {
        var _this = this;
        return React.createElement("label", { className: this.question.getSwatchCss(), style: this.question.getSwatchStyle() },
            React.createElement(SvgIcon, { iconName: this.question.cssClasses.swatchIcon, size: "auto" }),
            React.createElement("input", { type: "color", disabled: this.isDisplayMode, value: this.question.renderedColorValue, className: this.question.cssClasses.colorInput, onChange: function (event) { return _this.question.onColorInputChange(event.nativeEvent); }, tabIndex: -1, "aria-required": this.question.a11y_input_ariaRequired, "aria-labelledby": this.question.a11y_input_ariaLabelledBy, "aria-label": this.question.a11y_input_ariaLabel, "aria-invalid": this.question.a11y_input_ariaInvalid, "aria-describedby": this.question.a11y_input_ariaDescribedBy }));
    };
    SurveyQuestionColor.prototype.renderDropdownAction = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { "aria-hidden": "true", className: this.question.cssClasses.choicesButtonWrapper }, ReactElementFactory.Instance.createElement("sv-action-bar-item", { item: this.question.dropdownAction })),
            this.renderPopup()));
    };
    SurveyQuestionColor.prototype.renderPopup = function () {
        return React.createElement(Popup, { model: this.question.dropdownAction.popupModel });
    };
    return SurveyQuestionColor;
}(SurveyQuestionText));
export { SurveyQuestionColor };
ReactQuestionFactory.Instance.registerQuestion("color", function (props) {
    return React.createElement(SurveyQuestionColor, props);
});
